const productionEndpoints = {
  packageInfo: 'https://tx1ckwg0hi.execute-api.us-east-1.amazonaws.com/prod/getpackageinfo',
  registrationCheck: 'https://tx1ckwg0hi.execute-api.us-east-1.amazonaws.com/prod/checkifregistered',
  cognito: 'https://tx1ckwg0hi.execute-api.us-east-1.amazonaws.com/prod/register',
  payment: 'https://9hqqqnhnqg.execute-api.us-east-1.amazonaws.com/prod/registeruser',
  discount: 'https://dyoxtibws7.execute-api.us-east-1.amazonaws.com/prod/discounttoken'
};

const configuredEndpoint = (configuredValue, productionEndpoint) => {
  const configured = configuredValue?.trim();
  return configured || productionEndpoint;
};

// Signup works in every build by default. Set these variables to use another environment.
const signupApiConfig = {
  packageInfoUrl: configuredEndpoint(process.env.REACT_APP_PACKAGE_INFO_URL, productionEndpoints.packageInfo),
  registrationCheckUrl: configuredEndpoint(process.env.REACT_APP_SIGNUP_CHECK_URL, productionEndpoints.registrationCheck),
  cognitoUrl: configuredEndpoint(process.env.REACT_APP_SIGNUP_COGNITO_URL, productionEndpoints.cognito),
  paymentUrl: configuredEndpoint(process.env.REACT_APP_SIGNUP_SUBMIT_URL, productionEndpoints.payment),
  discountUrl: configuredEndpoint(process.env.REACT_APP_SIGNUP_DISCOUNT_URL, productionEndpoints.discount)
};

export default signupApiConfig;
